export const projectsType = {
  GET_PROJECTS_LIST: "GET_PROJECTS_LIST",
  GET_SELECTED_PROJECT: "GET_SELECTED_PROJECT",
  GET_ADVANCE_SETTING: "GET_ADVANCE_SETTING",
  CLEAR_PROJECT_REDUCER: "CLEAR_PROJECT_REDUCER",
  PROJECT_ACCESS: "PROJECT_ACCESS",
};
